import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';

const Navbar = () => {
  const { cart } = useCart();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="flex-shrink-0 flex items-center">
              <img className="h-8 w-auto" src="/logo.png" alt="Samai" />
              <span className="ml-2 text-xl font-bold bg-gradient-to-r from-[#4636FF] to-[#F253EC] bg-clip-text text-transparent">Samai</span>
            </Link>
          </div>
          
          <div className="hidden md:flex items-center space-x-4">
            <Link to="/" className="px-3 py-2 rounded-md text-sm font-medium text-gray-700 hover:text-[#4636FF]">
              Home
            </Link>
            <Link to="/mocktests" className="px-3 py-2 rounded-md text-sm font-medium text-gray-700 hover:text-[#4636FF]">
              Mocktests
            </Link>
            <Link to="/checkout" className="relative px-3 py-2 rounded-md text-sm font-medium text-gray-700 hover:text-[#4636FF]">
              Cart
              {cart.length > 0 && (
                <span className="absolute top-0 right-0 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-white transform translate-x-1/2 -translate-y-1/2 bg-[#F253EC] rounded-full">
                  {cart.length}
                </span>
              )}
            </Link>
          </div>
          
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-[#4636FF] focus:outline-none"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {isMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isMenuOpen && (
        <div className="md:hidden">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            <Link to="/" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-[#4636FF]">
              Home
            </Link>
            <Link to="/mocktests" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-[#4636FF]">
              Mocktests
            </Link>
            <Link to="/checkout" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-[#4636FF]">
              Cart ({cart.length})
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;